import React from 'react';

class Footer extends React.Component {
    render() {
        return (
            <div className="Footer">
                <h4>Copyright © 2019 Yummy Tummy | API: Zomato</h4>
                
            </div>
        );


    }
};


export default Footer;